import axios from "axios"
import useSWR from "swr"
import {API_USERS} from "../constants/apiUrls"
import currentAuthSession from "../aws/cognito/currentAuthSession"

export default function useProfilePicture(userId, accessToken, setSessionAction) {

    const fetcher = async (url) => {
        try {
            const response = await axios.get(url, {headers: {Authorization: `Bearer ${accessToken}`}, responseType: "blob"})
            return URL.createObjectURL(response.data)
        } catch (error) {
            if (error.response?.status === 401) {
                try {
                    await currentAuthSession()
                    .then(async (response) => {
                        setSessionAction({type: "REFRESH_COGNITO_TOKEN", payload: {idToken: response.idToken.toString()}})
                        const newToken = response.idToken.toString()
                        const retryRes = await axios.get(url, {headers: {Authorization: `Bearer ${newToken}`}})
                        return retryRes.data
                    })
                } catch (refreshError) {
                    throw refreshError
                }
            }
            throw error
        }
    }

    const {data, mutate, error} = useSWR(`${API_USERS}/${userId}/picture`, fetcher, {revalidateOnFocus: false})

    return {
        profilePicture: data,
        mutateProfilePicture: mutate,
        isLoadingProfilePicture: !error && !data,
        isErrorProfilePicture: error
    }
}